import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-modal-option-panel',
  templateUrl: './modal-option-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalOptionPanelComponent {}
